function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIntegrate = function SvgIntegrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 400 400"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M200 363.33V37.64M37.15 200.49h325.7",
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.48 200.59q0-5-.41-10a12.09 12.09 0 0 0-8-10.32l-21.77-7.74a12.13 12.13 0 0 1-7.37-15.49c.14-.39.3-.78.48-1.16l9.91-20.86a12.07 12.07 0 0 0-1.62-13A121.49 121.49 0 0 0 278.62 108a12.08 12.08 0 0 0-13-1.63l-20.87 9.92a12.12 12.12 0 0 1-16.15-5.73c-.18-.38-.34-.76-.48-1.15l-7.74-21.77a12.05 12.05 0 0 0-10.32-8q-4.92-.42-10-.42c-3.35 0-6.69.14-10 .42a12 12 0 0 0-10.31 8l-7.74 21.77a12.13 12.13 0 0 1-15.49 7.37 11.37 11.37 0 0 1-1.14-.47l-20.86-9.92a12.08 12.08 0 0 0-13 1.63 121.93 121.93 0 0 0-14.06 14 12.09 12.09 0 0 0-1.62 13l9.92 20.86a12.15 12.15 0 0 1-5.76 16.21c-.38.17-.76.33-1.15.47l-21.77 7.74a12.09 12.09 0 0 0-8 10.32c-.27 3.28-.4 6.6-.41 9.95s.13 6.69.41 10a12.07 12.07 0 0 0 8 10.31l21.77 7.74a12.13 12.13 0 0 1 7.37 15.49 9.56 9.56 0 0 1-.47 1.15l-9.92 20.86a12.09 12.09 0 0 0 1.62 13 122.82 122.82 0 0 0 14.06 14.06 12.09 12.09 0 0 0 13 1.62l20.86-9.92a12.15 12.15 0 0 1 16.18 5.75c.17.38.33.76.47 1.15l7.74 21.76a12 12 0 0 0 10.31 8c3.28.27 6.61.4 10 .41s6.7-.13 10-.41a12.09 12.09 0 0 0 10.32-8l7.74-21.76a12.14 12.14 0 0 1 15.49-7.38c.39.14.77.3 1.15.48l20.87 9.92a12.09 12.09 0 0 0 13-1.62 122.73 122.73 0 0 0 14.05-14.06 12.07 12.07 0 0 0 1.62-13l-9.91-20.86a12.13 12.13 0 0 1 5.73-16.17c.38-.18.77-.34 1.16-.48l21.71-7.75a12.07 12.07 0 0 0 8-10.31q.48-4.94.48-9.96Z",
    style: {
      fill: "#e9e3dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.24 98.43 14.01-14M83.94 314.73l14.01-14M97.95 98.43l-14.01-14M314.25 314.73l-14.01-14",
    style: {
      fill: "none",
      stroke: "#d8d8d8",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.04,
    cy: 200.62,
    r: 65.57,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.10000000149011612
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.22,
    cy: 236.12,
    rx: 27.81,
    ry: 3.19,
    style: {
      fill: "#222"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.83 180.89s0 14.34 5 19.12 14.69 8 18.1 5.57 5.77-8.76 1.57-13.54-11.54-6.37-16.26-7.17a19.31 19.31 0 0 1-8.41-3.98ZM210.44 191.24s-8.92-4.78-15.48-4-11.55 4-13.12 9.56 1.84 9 5.77 10.36c4.2 1.59 8.92 0 12.33-6.38 3.15-6.08 10.5-9.54 10.5-9.54Z",
    style: {
      fill: "#23c388"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.07 234.53s1.57 3.18 5.77 0c0 0-1.57-11.16-1.57-14.34a19 19 0 0 1 .78-8.77c1.58-4 8.92-10.35 10.76-11.94s5-4 3.15-4-5.77 1.6-9.71 5.58a85.59 85.59 0 0 0-7.35 8s-4.19-8-6.55-10.35-8.92-9.56-11.55-8 4.2 4.78 5.77 6.38 8.92 11.94 10 15.13c.5 3.19.5 22.31.5 22.31Z",
    style: {
      fill: "#009e7d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.10000000149011612
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.08,
    cy: 222.07,
    rx: 26.58,
    ry: 3.32,
    style: {
      fill: "#222"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m215.14 158.12 23.1 36.88s1.94.89 1.55-.53-13-31.53-13-31.53-4.08 1.07-5.82-.36a24.16 24.16 0 0 1-3.89-5Z",
    style: {
      fill: "#b2bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.22 163.82.39 58.07s-1.94 2-6.79 0l1.55-58.07Z",
    style: {
      fill: "#9da6aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.47 158.12-46.18-.54s-1.75 1.07-.39 1.43c1.55.36 36.09 5.88 36.09 5.88s1.17-3.74 3.3-4.46a39.44 39.44 0 0 1 6.6-.53Z",
    style: {
      fill: "#b2bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.47 161 241 124.45s-.19-2-1.36-.89-23.48 25.83-23.48 25.83 2.91 2.85 2.53 4.81a29.18 29.18 0 0 1-2.72 5.52Z",
    style: {
      fill: "#b2bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 163.82h-8v-6.77s-.19-1.78 2.33-1.78h3.3s2.13 0 2.13 1.78c.24 1.6.24 6.77.24 6.77Z",
    style: {
      fill: "#d7dcde"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.08,
    cy: 159.54,
    rx: 3.49,
    ry: 3.21,
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIntegrate;